export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";